/**
 * refresh-watchlist-item-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Message } from "../general/message";
import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

/**
 * A client transmits a {@link RefreshWatchlistItemRequest} to indicate that
 * the "summary" data on a watchlist entry has fallen out of date with the
 * actual data on the subject context.
 */
export class RefreshWatchlistItemRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_REFRESH_WATCHLIST_ITEM;
	public static tag : MessageTag = MessageTag.REQ_REFRESH_WATCHLIST_ITEM;

  /**
   * Construct a new {@link RefreshWatchlistItemRequest}.
   */
  constructor (public objectId : number, public watchId : number)
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/watchlists/refresh-watchlist-item-request.ts